<template>
  <div>
    <v-row
      v-for="sector in sectors"
      :key="sector.codigo"
      no-gutters
      class="py-5 sector-box"
      :class="!hasProductAvaiable(sector) ? 'cursor-default' : ''"
      :style="
        hoverShape &&
        sector.codigo === hoverShape &&
        sector.mapa_coordenadas &&
        sector.mapa_coordenadas.length
          ? 'background-color: rgba(255,255,0,0.1)'
          : ''
      "
      align="center"
      @mouseenter="$store.commit('SET_HOVER_SHAPE', sector.codigo)"
      @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
      @click="selectSector(sector)"
    >
      <v-col class="px-6">
        <v-row no-gutters>
          <span
            class="accent--text checkout-h6"
            style="font-weight: 450 !important"
            >{{ sector.nome }}</span
          >
        </v-row>
        <v-row no-gutters>
          <span class="primary--text checkout-h4">{{
            rangeByType(sector.products)
          }}</span>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>

      <v-chip
        class="mr-5"
        v-if="!hasProductAvaiable(sector)"
        outlined
        color="#838D9B"
        >Esgotado</v-chip
      >
      <v-icon v-else class="mr-5">mdi-chevron-right</v-icon>
    </v-row>
    <AlertDialog />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AlertDialog from "../sector/AlertDialog.vue";
export default {
  props: ["sectors"],
  computed: {
    ...mapGetters([
      "couponDetails",
      "couponApplied",
      "selectedSector",
      "cartProducts",
      "hoverShape",
      "eventId",
    ]),
  },
  methods: {
    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;
      productTypes.forEach((type) => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }
          if (max < value) {
            max = value;
          }
        }
      });
      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return "";
      }
      min = this.$options.filters.currency(min);
      max = this.$options.filters.currency(max);
      return min !== max ? `A partir de ${min}` : min;
    },

    selectSector(sector) {
      if (this.hasProductAvaiable(sector)) {
        if (
          this.cartProducts.length &&
          this.selectedSector &&
          this.selectedSector.codigo !== sector.codigo
        ) {
          this.$store.commit("SET_CHOSEN_SECTOR", sector);
          this.$store.commit("SET_ALERT_SECTORS", true);
        } else {
          let params = {
            event_id: this.eventId,
            sector_id: sector.codigo,
          };
          if (this.couponDetails && this.couponDetails.isCupomValid)
            params.coupon = this.couponDetails.cupomData.campaign_coupon;
          this.$store.dispatch("getSeatsSector", params);
          this.$store.commit(
            "SET_SELECTED_SECTOR",
            this.selectedSector ? this.selectedSector : sector
          );
          localStorage.setItem(
            `sector-selected-${this.eventId}`,
            JSON.stringify(sector)
          );
          localStorage.setItem(`show-map-${this.eventId}`, "true");
          this.$store.commit("SET_SHOW_SEAT_MAP", true);
        }
      }
    },

    hasProductAvaiable(sector) {
      const findedProduct = sector.products.find((p) => !p.esgotado);

      return !!findedProduct;
    },
  },
  components: { AlertDialog },
};
</script>

<style scoped>
.sector-box {
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
}

.cursor-default {
  cursor: default !important;
}
</style>
